<template>
  <div>
    <!-- Payment Summary Section Start -->
    <div class="row">
      <div class="col-md-12 gutr">
        <div class="box-body gutr">
          <h5>
            <b-badge variant="warning">Additional Task Request</b-badge>
          </h5>
          <table id="otherAdditionalTask" class="table table-bordered table-sm gutr">
            <thead style="background-color:aquamarine;color:black">
              <tr>
                <th>SN</th>
                <th>Task No.</th>
                <th>Expense</th>
                <th>Exp Amount</th>
                <th>Bill to Customer</th>
                <th>Selling Amount</th>
                <th>Remark</th>
                <th>Added on</th>
              </tr>
            </thead>
            <tbody>
              <!-- {{otherAdditionalTask_Data}} -->
              <tr v-for="(item, index) in otherAdditionalTask_Data" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.AMTSeries }}</td>
                <td>{{ item.ledger }}</td>
                <td>{{ item.amount }}</td>
                <td>{{ item.scCategory }}</td>
                <td>{{ item.selling_amt }}</td>
                <td>{{ item.remark }}</td>
                <td>{{ item.loginTime }}</td>
              </tr>
              <tr v-if="otherAdditionalTask_Data.length <= 0">
                <td colspan="4" style="text-align: center; color: red">
                  <b>NO Additional Task Request ADDED</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="box-body gutr">
          <h5>
            <b-badge variant="info">Sline Payment Details</b-badge>
          </h5>
          <table id="otherAdditionalTask" class="table table-bordered table-sm gutr">
            <tbody>
              <tr>
                <th>SN</th>
                <th>Invoice No</th>
                <th>Invoice Category</th>
                <th>Invoice Type</th>
                <th>Invoice Amount</th>
                <th>Payment Mode</th>
                <th>Payment Refrence No.</th>
                <th>Payment Amount</th>
                <th>Payment Date</th>
                <th>Payment Status</th>
                <th>Bill to Shipper</th>
                <th>Bill to Shipper Remark</th>
              </tr>

              <tr v-for="(item, index) in SlinePayment_Data" :key="index">
                <td>{{ index + 1 }}</td>
                <td>
                  <a style="color: blue" v-if="item.SlineUpload" href="javascript:void(0)" @click="openSignedDocument(`ASSIGNMENT_UPLOADS/${PMS_jb_series.replaceAll('/', '_')}/${item.SlineUpload.replaceAll('/', '_')}`)"><b><u>{{ item.SlineInvNo }}</u></b></a>
                </td>
                <td>{{ item.SlineInvCategory }}</td>
                <td>{{ item.newSlineInvType }}</td>
                <td>{{ item.SlineInvAmount }}</td>
                <td>
                  <span v-if="item.SlineInvPayMode == 1">RTGS</span>
                  <span v-else-if="item.SlineInvPayMode == 2">Cheque</span>
                  <span v-else></span>
                </td>
                <td>{{ item.SlineInvPayRef }}</td>
                <td>{{ item.SlineInvPaidAmount }}</td>
                <td>{{ item.SlineInvPayDate }}</td>
                <td>
                  <span v-if="item.SlineInvPayStatus == 1">Partial</span>
                  <span v-else-if="item.SlineInvPayStatus == 2">Completed</span>
                  <span v-else>Pending</span>
                </td>
                <td>{{ item.scCategory }}</td>
                <td>{{ item.scremark }}</td>
              </tr>
              <tr v-if="SlinePayment_Data.length <= 0">
                <td colspan="7" style="text-align: center; color: red">
                  <b>NO Sline Payment Details</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="box-body gutr">
          <h5>
            <b-badge variant="info">Expense Document Details</b-badge>
          </h5>
          <table id="otherAdditionalTask" class="table table-bordered table-sm gutr">
            <tbody>
              <tr>
                <th>SN</th>
                <th>Expense Date</th>
                <th>View</th>
                <th>Remark</th>
                <th>Doc. Adding Time</th>
                <th>Doc. Added By</th>
              </tr>

              <!-- {{ ExpenseDoc_Data }} -->
              <tr v-for="(item, index) in ExpenseDoc_Data" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.expenseDate }}</td>
                <td>
                  <a style="color: blue" v-if="item.documentLink" href="javascript:void(0)" @click="openSignedDocument(`ASSIGNMENT_UPLOADS/${PMS_jb_series.replaceAll('/', '_')}/${item.documentLink.replaceAll('/', '_')}`)">
                    <b><u>{{ item.otherDocName }}</u></b>
                  </a>
                </td>

                <td>{{ item.docRemarks }}</td>
                <td>{{ item.doc_added_date }}</td>
                <td>{{ item.employeeName }}</td>
              </tr>
              <tr v-if="ExpenseDoc_Data.length <= 0">
                <td colspan="2" style="text-align: center; color: red">
                  <b>NO Expense Document ADDED</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="box-body gutr">
          <h5>
            <b-badge variant="info">Expense Charges Details</b-badge>
          </h5>
          <table id="otherTallyExpCharges" class="table table-bordered table-sm gutr">
            <tbody>
              <tr>
                <th>SN</th>
                <th>Exp No</th>
                <th>Exp Type</th>
                <th>Exp Date</th>
                <th>Vendor Name</th>
                <th>Vendor GST</th>
                <th>AMT</th>
                <th>GST AMT</th>
                <th>TOT AMT</th>
                <th>Remark</th>
              </tr>

              <tr v-for="(item, index) in otherTallyExpCharges" :key="index">
                <td>{{ index + 1 }}</td>
                <td>
                  <b-button @click="showExpenseDet(item)" variant="outline-info" size="xs" style="font-size: 0.675rem"
                    class="mt-1">{{ item.docDtls_No }}</b-button>
                </td>
                <td>{{ item.docDtls_Typ }}</td>
                <td>{{ item.Exp_Date }}</td>
                <td>{{ item.vendorName }}</td>
                <td>{{ item.vendorGST }}</td>
                <td>{{ item.AMT }}</td>
                <td>
                  {{
                    parseFloat(item.CGST) +
                    parseFloat(item.SGST) +
                    parseFloat(item.IGST) +
                    parseFloat(item.CesVal) +
                    parseFloat(item.StCesVal) +
                    parseFloat(item.OthChrg) +
                    parseFloat(item.RndOffAmt) -
                    parseFloat(item.Discount)
                  }}
                </td>
                <td>{{ item.TotInvVal }}</td>
                <td>{{ item.ExpContainersNo }}</td>
              </tr>
              <tr v-if="otherTallyExpCharges.length <= 0">
                <td colspan="10" style="text-align: center; color: red">
                  <b>NO Expense Document ADDED</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <OldExpenseAdditionalTask
          v-if="all_module_id"
          :allModuleId="all_module_id"
          type="additional-task"
        />
      </div>
    </div>

    <b-modal id="otherTallyExpCharges-modal" ref="otherTallyExpCharges-modal" :title="modal_title + modal_JobNo"
      size="xl" no-close-on-esc no-close-on-backdrop hide-footer>
      <div class="row">
        <div class="col-md-12 row">
          <div class="col-md-12">
            <table id="tpt" class="table table-bordered">
              <thead>
                <tr>
                  <th>SN.</th>
                  <th>Particulars</th>
                  <th>Quantity</th>
                  <th>Barcode</th>
                  <th>HSNCode</th>
                  <th>Amount</th>
                  <th>GST Rate</th>
                  <th>IGST Amt</th>
                  <th>CGST Amt</th>
                  <th>SGST Amt</th>
                  <th>Cest Rt/Amt</th>

                  <th>Amt</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item1, index) in ExpenseItemDeatils" :key="index">
                  <td>{{ index + 1 }}</td>

                  <td>{{ item1.prdDesc }}</td>
                  <td>{{ item1.qty }}</td>
                  <td>{{ item1.barcde }}</td>
                  <td>{{ item1.hsnCd }}</td>
                  <td>
                    {{ item1.totAmt }}
                  </td>
                  <td>{{ item1.gstRt }}</td>
                  <td>
                    {{ item1.igstAmt }}
                  </td>
                  <td>{{ item1.cgstAmt }}</td>
                  <td>{{ item1.sgstAmt }}</td>
                  <td>{{ item1.cesRt }} / {{ item1.cesAmt }}</td>
                  <td>{{ item1.assAmt }}</td>
                  <td>{{ item1.totItemVal }} {{ item1.orgCntry }}</td>
                </tr>
              </tbody>
            </table>
            <br />
            <div>
              <b>Amount + Tax = Total Amount </b>
              <br />
              <b>{{ singleItem.AMT }} + {{ taxAmount }} =
                {{ singleItem.TotInvVal }}
              </b>
            </div>
          </div>
          <div class="col-md-12 text-center">
            <center>
              <b-button @click="hideExpenseDet" style="font-size: 11px" size="sm" class="mt-1" variant="danger">
                Close</b-button>
            </center>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- Payment Summary Section End -->
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, GlobalGetLocation } from "../../helper/collection";
import OldExpenseAdditionalTask from '../allModuleForm/components/OldExpenseAdditionalTask.vue'

export default {
  props: ["PMS_job_type", "PMS_fk_all_module_id", "PMS_jb_series", "PMS_fk_client_id"],
  beforeMount() {
    if (this.PMS_fk_all_module_id != "") {
      this.getData();
    }
  },
  mounted() { },

  data() {
    return {
      singleItem: "",
      taxAmount: 0,
      modal_title: "",
      modal_JobNo: "",
      ExpenseItemDeatils: [],
      all_module_id: this.PMS_fk_all_module_id,
      otherExpenseData: [],
      otherAdditionalTask_Data: [],
      SlinePayment_Data: [],
      ExpenseDoc_Data: [],
      otherTallyExpCharges: [],
      docURL: URL_BASE_DOC,
    };
  },
  mounted() { },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },

  components: {
    Loading,
    DatePicker,
    ModelListSelect,
    OldExpenseAdditionalTask,
  },

  computed: {},
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getData();
      },
      deep: true,
    },
  },
  methods: {
    showExpenseDet(item) {
      this.singleItem = item;
      this.ExpenseItemDeatils = [];
      this.taxAmount = 0;
      this.ExpenseItemDeatils = item.ExpenseItemDeatils;
      this.taxAmount =
        ((parseFloat(this.ExpenseItemDeatils.CGST) +
          parseFloat(this.ExpenseItemDeatils.SGST) +
          parseFloat(this.ExpenseItemDeatils.IGST) +
          parseFloat(this.ExpenseItemDeatils.CesVal) +
          parseFloat(this.ExpenseItemDeatils.StCesVal) +
          parseFloat(this.ExpenseItemDeatils.RndOffAmt) +
          parseFloat(this.ExpenseItemDeatils.OthChrg)) -
          parseFloat(this.ExpenseItemDeatils.Discount));
      this.modal_title = "Expense Item List - Exp No-" + item.docDtls_No + " Job No - ";
      this.modal_JobNo = item.ExpjobNo;
      this.$refs["otherTallyExpCharges-modal"].show();
    },
    hideExpenseDet() {
      this.singleItem = "";
      this.ExpenseItemDeatils = [];
      this.taxAmount = 0;
      this.$refs["otherTallyExpCharges-modal"].hide();
    },
    getData() {
      if (this.PMS_fk_all_module_id != "") {
        let payload = {
          filter: "PaymentSummary",
          allModuleId: this.PMS_fk_all_module_id,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/viewAssignmentTrackDetails.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              // console.log(data);
              this.otherExpenseData = [];
              this.otherAdditionalTask_Data = [];
              this.SlinePayment_Data = [];
              this.ExpenseDoc_Data = [];
              this.otherTallyExpCharges = [];
              if (data.otherExpenseData.length > 0) {
                this.$nextTick(() => {
                  this.otherExpenseData = data.otherExpenseData;
                });
              }
              if (data.otherAdditionalTask_Data.length > 0) {
                this.$nextTick(() => {
                  this.otherAdditionalTask_Data = data.otherAdditionalTask_Data;
                });
              }
              // console.log("data.SlinePayment_Data=>", data.SlinePayment_Data);
              // console.log(
              //   "data.SlinePaymentQuery_Data=>",
              //   data.SlinePayment_Data
              // );
              if (data.SlinePayment_Data.length > 0) {
                this.$nextTick(() => {
                  this.SlinePayment_Data = data.SlinePayment_Data;
                });
              }
              // console.log(
              //   "this.SlinePaymentQuery_Data=>",
              //   this.SlinePayment_Data
              // );
              // console.log(
              //   "data.ExpenseDocQuery_Data=>",
              //   data.ExpenseDocQuery_Data
              // );
              // console.log("data.ExpenseDoc_Data=>", data.ExpenseDoc_Data);
              if (data.ExpenseDoc_Data.length > 0) {
                this.$nextTick(() => {
                  this.ExpenseDoc_Data = data.ExpenseDoc_Data;
                });
              }

              if (data.otherTallyExpCharges.length > 0) {
                this.$nextTick(() => {
                  this.otherTallyExpCharges = data.otherTallyExpCharges;
                });
              }
            }
          })
          .catch((error) => { });
      }
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}

.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}

.table-wrapper-scroll-y {
  display: block;
}
</style>



// WEBPACK FOOTER //
// paymentSummary.vue?1782255a